import { render, staticRenderFns } from "./AssignUserPermissionGroup.vue?vue&type=template&id=377c9c6d&scoped=true"
import script from "./AssignUserPermissionGroup.vue?vue&type=script&lang=js"
export * from "./AssignUserPermissionGroup.vue?vue&type=script&lang=js"
import style0 from "./AssignUserPermissionGroup.vue?vue&type=style&index=0&id=377c9c6d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "377c9c6d",
  null
  
)

export default component.exports